export const ListQueryKey = 'registrationRecords';
export const DetailQueryKey = 'registrationRecord';

export const Urls = {
  selectUrl: '/registrationRecord/list',
  updateUrl: '/registrationRecord/update',
  deleteUrl: '/registrationRecord/delete',
  createUrl: '/registrationRecord/create',
  detailUrl: '/registrationRecord/info',
};
